import axios from "axios";

export const Axios = axios.create({
  baseURL: "https://apisl.tmsosial.asia/api/",
  timeout: 10000,
  headers: {},
});
